import types from "./types";

const INITIAL_STATE = {
	publicFormBuilder: null,

	publicFormBuilderError: null,
	publicFormBuilderLoading: false,

	//select item

	selectItem: null,
};

const PublicFromReducer = (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case types.GET_PUBLICFORMLIST_START:
			return {
				...state,
				publicFormBuilder: null,
				publicFormBuilderError: null,
				publicFormBuilderLoading: true,
			};
		case types.GET_PUBLICFORMLIST_SUCCESS:
			return {
				...state,
				publicFormBuilder: action.payload,
				publicFormBuilderLoading: false,
			};
		case types.GET_PUBLICFORMLIST_ERROR:
			return {
				...state,
				publicFormBuilderError: action.payload,
				publicFormBuilderLoading: false,
			};
		case types.GET_PUBLICFORMLIST_RESET:
			return {
				...state,
				publicFormBuilderError: null,
				publicFormBuilderLoading: false,
			};
		//create

		case types.SELECT_TOUPDATE_ITEM:
			return {
				...state,
				selectItem: action.payload,
			};

		default:
			return { ...state };
	}
};

export default PublicFromReducer;
